module.exports = __webpack_public_path__ + "static/Bilxtrahjelpstor2-2f5b7ae287725a2671fac8daad2653e4.png";